import { useEffect, useState } from "react";

// 전역으로 input이나 textarea에 포커스가 있는지 확인하는 훅
export const useGlobalInputFocus = () => {
    const [isInputFocused, setIsInputFocused] = useState(false);

    useEffect(() => {
        const handleFocusIn = (e: FocusEvent) => {
            const target = e.target as HTMLElement;
            
            if (target && (target.tagName === "INPUT" || target.tagName === "TEXTAREA")) {
                setIsInputFocused(true);
            }
        };

        const handleFocusOut = (e: FocusEvent) => {
            const relatedTarget = e.relatedTarget as HTMLElement | null;

            if (
                !relatedTarget || 
                !(relatedTarget.tagName === "INPUT" || relatedTarget.tagName === "TEXTAREA")
            ) {
                setIsInputFocused(false);
            }
        };

        window.addEventListener("focusin", handleFocusIn);
        window.addEventListener("focusout", handleFocusOut);

        return () => {
            window.removeEventListener("focusin", handleFocusIn);
            window.removeEventListener("focusout", handleFocusOut);
        };
    }, []);

    return isInputFocused;
};
